/**
 * React Static Boilerplate
 * https://github.com/kriasoft/react-static-boilerplate
 *
 * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import URI from 'urijs';
import  {createPath,parsePath} from 'history';
import {find} from 'lodash';
import pageLoader from "./framework/loader";
import CryptoRequest from "./api/network/crypto-request";
import {parseMicroServiceSrc} from "./utils";
import LoadErrorPage from './container/LoadErrorPage';
// Find the route matching the specified location (context), fetch the required data,
// instantiate and return a React component

function pageContainerSupport(location){
  let pageUrl =createPath(location);
  let uri = new URI(pageUrl);
  if(pageUrl.indexOf("http") == 0){
    return true;
  }else if(uri.search(true)?.["$openType"] == 'app'){
    return true;
  }
  return false;
}

async function resolve(location,currentPage = getCurrentPageInfo()) {
  location = parsePath(CryptoRequest.parse(createPath(location)).toString(false));


  if(pageContainerSupport(location)){
    let {default: PageContainer} = await import('./container/PageContainer');
    return <PageContainer location={location}></PageContainer>
  }

  let params = URI.parseQuery(location.search);

  if(params  && params.executor instanceof Array){
    params.executor = params.executor[params.executor.length -1];
  }
  try{
    let Page = await  pageLoader.loadPage(location.pathname,params,currentPage);
    return <Page parentPath={Page.parentPath} serviceName={Page.serviceName} contextName={Page.contextName} loadMode={Page.loadMode} params={params} location={location}/>
  }catch(error){
    return <LoadErrorPage serviceName={error.serviceName} contextName={error.contextName} loadMode={error.loadMode} params={params}
                          location={location} msg={error.error}
                          error={error}
                          stack={error.stack}></LoadErrorPage>
  }
}
let pathName = location.pathname;
function getCurrentPageInfo(){
  let pageInfo = parseMicroServiceSrc(pathName);
  window.parentPath = window.parentPath ||  pageInfo.parentPath;
  return pageInfo;
}





export let findPageByRoute = function(route){
  let pageTarget = document.querySelector('[route="'+ route +'"]');
  if(pageTarget && pageTarget.page){
    return pageTarget.page;
  }
  //页面会销毁 仅仅警告即可
  return null;
}

let currentPages = [];
let result = { resolve,currentPages,findPageByRoute};

/**
 *  兼容wx.navigateTo 用对话框方式打开 兼容 router.currentPages 里面有一个
 *
 *  标准方案 弹框用modal组件
 *  打开页面 用this.navigateTo  this.navigateBack
 */
if(window.justep && window.justep.Shell && window.justep.Shell.impl){
  Object.defineProperty(result,"currentPages",{
    get: function () {
      //门户下的 激活页的 root节点
      let currentPage = document.querySelector(".x-portal-pages .x-contents-content.active [xid='root']")?.page;
      if(currentPage){
        return [currentPage];
      }else{
        return [];
      }
    },
    set : function(){
    }
  });
}

export default result;
